import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { ActionList, Button, Link, Popover } from '@superops/ui-design-system';
import { AccountClient, GET_INVOICE_DOWNLOAD_LINK } from '@nile/graphql';
import React, { useState, useEffect } from 'react';
import { SVGIcon } from '@superops/super-icons';
import { useProduct, COMMON_CONSTANTS, getHeaderValue } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { downloadHack } from '@nile/components/src/Utils/helpers';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';
import { useFlags } from 'launchdarkly-react-client-sdk';

function AttachmentCell(props) {
  const { cell, action } = props;
  const actions = cell.column.actions;
  const hasOverageDevice = cell?.row?.original?.hasOverageDevice;
  const flags = useFlags();
  const [downloadURL, setDownloadURL] = useState(null);
  const [popoverActive, setPopoverActive] = useState(false);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const intl = useIntl();
  // <Link {...cell.column.actions}>

  useEffect(() => {
    AccountClient.query({
      query: GET_INVOICE_DOWNLOAD_LINK,
      variables: { invoiceId: cell?.row?.original?.id },
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res?.data?.getInvoiceDownloadLink) {
        setDownloadURL(res.data.getInvoiceDownloadLink);
      }
    });
  }, []);

  const togglePopoverActive = () => {
    setPopoverActive(!popoverActive);
  };
  const downloadCsv = async () => {
    const baseURL = localStorage?.getItem('apiDomain') + envConfig.fileRoot;
    const billDate = dayjs(cell?.row?.original?.date).format('YYYY-MM');
    const downloadDetails = new URL(`${baseURL}/download`);
    downloadDetails.search = new URLSearchParams({
      module: 'BILLING_USAGE',
      details: JSON.stringify({
        'usage-type': 'asset-usage',
        'year-month': billDate
      })
    });
    const requestOptions = {
      method: 'GET',
      credentials: 'include',
      headers: getHeaderValue()
    };

    fetch(downloadDetails, requestOptions)
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data?.errors) {
          toast(
            'error',
            getTranslatedText(
              intl,
              `app.errorCode.${data.errors?.[0]?.errorCode}`
            )
          );
        }
      })
      .catch((error) => {
        downloadHack({
          href: downloadDetails.href,
          target: '_blank'
        });
      });
  };

  const attachmentActionList = [
    {
      content: getTranslatedText(intl, 'entity.Invoice'),
      iconName: 'PdfFile',
      onAction: () => {
        togglePopoverActive();
        downloadHack({
          href: downloadURL
        });
      }
    }
  ];

  if (hasOverageDevice) {
    attachmentActionList.unshift({
      content: getTranslatedText(
        intl,
        'itsm.app.pricing.overage.device.list.table.header'
      ),
      iconName: 'CsvImport',
      onAction: () => {
        togglePopoverActive();
        downloadCsv();
      }
    });
  }

  return isMSPProduct || !flags?.itOverageBilling ? (
    <Link removeUnderline url={downloadURL}>
      {getTranslatedText(intl, 'common.download')}
    </Link>
  ) : (
    <Popover
      active={popoverActive}
      activator={
        <Button
          size="slim"
          icon={<SVGIcon name="Download" />}
          onClick={togglePopoverActive}
        >
          {getTranslatedText(intl, 'common.download')}
        </Button>
      }
      onClose={togglePopoverActive}
      preferredAlignment="left"
    >
      <ActionList items={attachmentActionList} />
    </Popover>
  );
}

export default AttachmentCell;
